import { Injectable } from '@angular/core';

import { UserWithAccount } from '@tablesready/common-ui';
import { UserFilters } from '../../models';

@Injectable()
export class UsersFilterService {
  filter(
    { search, locationId, sortBy, sortReverse }: UserFilters,
    users: UserWithAccount[],
  ): UserWithAccount[] {
    const sortedUsers = this.sortUsers(sortBy, sortReverse, users);

    return sortedUsers.filter(user => this.compareBySearch(search, user) && this.compareByLocationId(locationId, user));
  }

  private compareBySearch(data: string, user: UserWithAccount): boolean {
    if (data === '') {
      return true;
    }

    const { name, email } = user;
    return name?.toLowerCase().includes(data) || email?.toLowerCase().includes(data);
  }

  private compareByLocationId(data: string | null, user: UserWithAccount): boolean {
    if (data) {
      const locations = user.locationUsers.filter(locationUser => locationUser.locationId === data);

      return locations.length > 0;
    }

    return true;
  }

  private sortUsers(sortBy: string | null, sortReverse: boolean, users: UserWithAccount[]): UserWithAccount[] {
    if (sortBy) {
      return sortReverse
        ? users.sort((currentUser, nextUser) => nextUser[sortBy].localeCompare(currentUser[sortBy]))
        : users.sort((currentUser, nextUser) => currentUser[sortBy].localeCompare(nextUser[sortBy]));
    }

    // return users;
    return users.sort((currentUser, nextUser) => {
      if (currentUser.role === nextUser.role) {
        return currentUser.name.localeCompare(nextUser.name);
      }

      return currentUser.role > nextUser.role ? 1 : -1;
    });
  }
}
